import { AxiosRequest } from "_services/api";
import { toastErro } from "components/Toast";
import { useCallback, useMemo, useState } from "react";
import { TipoSolicitacaoPlaca } from "../constants/tipoSolicitacaoPlaca";
import { mensagemDeErro } from "../utils/mensagemDeErro";

export interface IResultadoMoverTipo {
  alterados: number;
  ignorados: number;
}

export function useMoverTipoSolicitacao(destino: TipoSolicitacaoPlaca) {
  const msAw = useMemo(
    () => AxiosRequest.makeApi(process.env.REACT_APP_MS_AW),
    []
  );
  const [movendo, setMovendo] = useState(false);

  const mover = useCallback(
    async (idsSolicitacao: number[]): Promise<IResultadoMoverTipo | null> => {
      setMovendo(true);
      try {
        const { data } = await msAw.patch("/solicitacao-placa/tipo", {
          idsSolicitacao,
          tipo: destino,
        });
        return data;
      } catch (erro) {
        toastErro(mensagemDeErro(erro, "Erro ao mover as solicitações"));
        return null;
      } finally {
        setMovendo(false);
      }
    },
    [msAw, destino]
  );

  return { mover, movendo };
}
